import { useEffect, useState } from 'react';

const useMousePosition = () => {
  const [mouse, setMouse] = useState({ x: 0, y: 0 });

  const onMouse = ({ pageX, pageY }) => {
    setMouse({ x: pageX, y: pageY });
  };

  useEffect(() => {
    window.addEventListener('mousemove', onMouse);

    return () => {
      window.removeEventListener('mousemove', onMouse);
    };
  });

  return mouse;
};

export default useMousePosition;
